export const initialValues = {
  description: '',
  name: '',
  surfaces: '',
};

export const multiUploadColumns = [
  { headerName: 'Image' },
  { headerName: 'Name' },
  { headerName: 'Description' },
];
export const mediaColumns = [
  { headerName: 'Media' },
  { headerName: 'Name' },
  { headerName: 'Description' },
];

export const generalSection = () => [
  {
    field: 'name',
    type: 'text',
    required: false,
    size: 'half',
    maxLength: 50,
  },
  {
    field: 'description',
    type: 'textArea',
    required: false,
    placeholder: 'Enter description about the image',
    maxLength: 500,
  },
];

export const formLabels = {
  subFormHeader: 'sub_form_detail_image_title',
  title: 'Discard changes',
  buttonCancel: 'Cancel',
  buttonSubmit: 'Submit',
  cropModalTitle: 'Discard changes',
  cropModalUpdateButton: 'Update and close',
};

export const formikFormKeys = {
  multiImageUploadButtonText: 'Detailed Images',
  multiImageUploaderImageName: 'Image',
};
